import React, { useEffect, useRef, useState, lazy, Suspense } from "react";
import { motion } from "framer-motion";
import "./contact-info.css";

// Lazy load the Leaflet map component
const LeafletMap = lazy(() => import("../../../components/LeafletMap"));

const ContactLanding = () => {
  const ref = useRef(null);
  const [hideMap, setHideMap] = useState(true);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setHideMap(false);
            observer.unobserve(element);
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(element);

    return () => {
      if (element) observer.unobserve(element);
    };
  }, []);

  return (
    <motion.article
      className="homepage__contact flex-container flex-column"
      ref={ref}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 3 }}
    >
      {!hideMap && (
        <Suspense fallback={<div>Karte wird geladen...</div>}>
          <LeafletMap />
        </Suspense>
      )}
      <div className="contact__info">
        <h3>Kontaktiere uns – Lass uns über Pizza reden! 🍕</h3>
        <p>
          Hast du eine Frage, Lust auf Insiderwissen rund um Pizza oder möchtest einfach nur Ciao sagen? Wir sind ganz Ohr (und haben Teig an den Händen)! Ob Bestellanfrage, Kooperationsidee oder einfach nur Liebe zur Pizza – wir freuen uns, von dir zu hören.
        </p>
        <section>
          <h4>📞 Kundenservice – Frisch & Bereit für dich!</h4>
          <p>
            Unser engagiertes Team ist wie deine Lieblingspizza – warm, zuverlässig und immer zur Stelle, wenn du uns brauchst. Ob du Fragen zu einer Bestellung hast oder Hilfe benötigst – wir sind für dich da!
          </p>
          <ul>
            <li>
              - E-Mail:{" "}
              <a
                href="mailto:casa.itzling@gmail.com"
                className="footer__contact__link"
              >
                casa.itzling@gmail.com
              </a>
            </li>
            <li>
              - Telefon:{" "}
              <a
                href="tel:+436601919689"
                className="footer__contact__link"
              >
                +43 660 19 19 689
              </a>
            </li>
            <li>
              Öffnungszeiten: Montag – Freitag: 11:00 – 14:30 & 17:00 – 22:00, Samstag – Sonntag: 14:00 – 22:00
            </li>
          </ul>
        </section>
        <section>
          <h4>🍕 Allgemeine Anfragen – Geschäftliches im Kopf?</h4>
          <p>
            Möchtest du mit uns kooperieren, franchisen oder einfach nur über Pizza schwärmen? Schreib uns – gemeinsam lässt sich Großartiges backen!
          </p>
          <ul>
            <li>
              - E-Mail:{" "}
              <a
                href="mailto:casa.itzling@gmail.com"
                className="footer__contact__link"
              >
                casa.itzling@gmail.com
              </a>
            </li>
          </ul>
        </section>
        <section>
          <h4>⭐ Feedback & Vorschläge – Deine Meinung zählt!</h4>
          <p>
            Hast du eine geniale Pizza-Idee? Ist dir etwas aufgefallen, das wir verbessern können? Dein Feedback hilft uns, unsere Pizzen (und unseren Service) erstklassig zu halten. Sag uns, was dir auf dem Herzen liegt!
          </p>
          <ul>
            <li>
              - E-Mail:{" "}
              <a
                href="mailto:casa.itzling@gmail.com"
                className="footer__contact__link"
              >
                casa.itzling@gmail.com
              </a>
            </li>
          </ul>
        </section>
      </div>
    </motion.article>
  );
};

export default ContactLanding;
